<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-cubes mr-2" />Barang</h5>
            <hr />
            <b-row>
                <b-col md="3">
                    <b-form-group label="Nama Barang" id="nama-barang-group">
                        <b-form-input v-model="filter.name" maxlength="50" @keydown.enter="getItems" id="nama-barang-input" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Jenis" id="jenis-group">
                        <multiselect v-model="filter.kind" label="name" track-by="id" :internal-search="true"
                            deselect-label="" select-label="" :options="optKind" id="jenis-select" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Merk" id="merk-group">
                        <multiselect v-model="filter.brand" label="name" track-by="id" :internal-search="true"
                            deselect-label="" select-label="" :options="optBrand" id="merk-select" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Ada Grade S?" id="grade-s-group">
                        <b-form-select v-model="filter.gradeS" id="grade-s-select">
                            <b-form-select-option value="-1">Semua</b-form-select-option>
                            <b-form-select-option value="1">Ada Grade S</b-form-select-option>
                            <b-form-select-option value="0">Tanpa Grade S</b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3">
                    <b-form-group label="Berdasarkan Tahun / Generasi?" id="has-year-group">
                        <b-form-select v-model="filter.hasYear" id="has-year-select">
                            <b-form-select-option value="-1">Semua</b-form-select-option>
                            <b-form-select-option value="1">Barang Bertahun</b-form-select-option>
                            <b-form-select-option value="0">Barang Tanpa Tahun</b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col md="9">
                    <b-form-group label="Aksi" id="action-group">
                        <div class="d-flex justify-content-between">
                            <div>
                                <b-button variant="primary" class="mb-2" @click="getItems()" id="search-button">
                                    <i class="fa fa-search mr-2" />Cari
                                </b-button>
                                <b-button class="ml-2 mb-2" variant="danger" @click="resetFilter()" id="reset-filter-button">
                                    <i class="fa fa-eraser mr-2" />Reset
                                </b-button>
                            </div>
                            <div>
                                <b-dropdown variant="success" right class="mb-2" id="dropdown-download-excel">
                                    <template #button-content>
                                        <i class="fa fa-download mr-2"></i> Export / Import
                                    </template>
                                    <b-dropdown-item-button @click="generateItemMaster()" id="download-master-button">
                                        Download Master
                                    </b-dropdown-item-button>

                                    <!-- <b-dropdown-item-button @click="downloadItemTemplate()">
                                        Download Template
                                    </b-dropdown-item-button> -->
                                    <!-- <b-dropdown-item-button @click="prepareUploadTemplate()">
                                        Upload Template
                                    </b-dropdown-item-button> -->
                                    
                                    <!-- Hide for now waiting API exist -->
                                    <!-- <b-dropdown-item-button @click="generatePriceList()" id="download-price-button">
                                        Download Price
                                    </b-dropdown-item-button> -->

                                    <b-dropdown-item-button v-if="isAllowedGradeS" @click="openModalDownloadGradeS()" id="download-grade-s-template-button">
                                        Template Grade S
                                    </b-dropdown-item-button>
                                    <b-dropdown-item-button v-if="isAllowedGradeS" @click="openModalUploadGradeS()" id="upload-grade-s-template-button">
                                        Import Grade S
                                    </b-dropdown-item-button>
                                </b-dropdown>
                            </div>
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting :busy="isBusy" :items="items" :fields="fields"
                @sort-changed="onSortChanged" responsive class="mb-3" id="items-table">
                <template v-slot:empty>
                    Tidak ada data barang.
                </template>
                <template v-slot:cell(item)="row">
                    {{ row.item.type }}
                    <div class="small text-muted">{{ row.item.kind }} - {{ row.item.brand }}</div>
                </template>
                <template v-slot:cell(price)="row">
                    <div v-if="row.item.has_year == 1" class="text-muted">Berdasarkan Tahun / Gen</div>
                    <div v-else>Rp. {{ $helper.formatThousand(row.item.price) }}</div>
                </template>
                <template v-slot:cell(adj_batangan)="row">
                    <div v-if="!row.item.isEditing">
                        <div v-if="row.item.has_year == 1" class="text-muted">Berdasarkan Tahun / Gen</div>
                        <div v-else-if="row.item.adj_batangan == null" class="text-muted">Tidak ada Adjustment Batangan
                        </div>
                        <div v-else>Rp. {{ $helper.formatThousand(row.item.adj_batangan) }}</div>
                    </div>
                    <div v-else>
                        <b-form-group label="Batangan">
                            <b-input-group prepend="Rp.">
                                <b-form-input v-model="row.item.editBatangan"
                                    @input="sanitize(row.index, row.item, 'editBatangan')"
                                    :disabled="row.item.isSubmitting" id="edit-batangan-input"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </div>
                </template>
                <template v-slot:cell(adj_grade_s)="row">
                    <div v-if="!row.item.isEditing">
                        <div v-if="row.item.has_year == 1" class="text-muted">Berdasarkan Tahun / Gen</div>
                        <div v-else-if="row.item.adj_grade_s == null" class="text-muted">Tidak ada Grade S</div>
                        <div v-else>Rp. {{ $helper.formatThousand(row.item.adj_grade_s) }}</div>
                    </div>
                    <div v-else>
                        <b-form-group label="Grade S">
                            <b-input-group prepend="Rp.">
                                <b-form-input v-model="row.item.editGradeS"
                                    @input="sanitize(row.index, row.item, 'editGradeS')"
                                    :disabled="row.item.isSubmitting" id="edit-grade-s-input"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </div>
                </template>
                <template v-slot:cell(specs)="row">
                    <div v-if="!row.item.isEditing">
                        <div v-if="row.item.has_year == 1" class="text-muted">Berdasarkan Tahun / Gen</div>
                        <div v-else-if="row.item.hasSpecs">
                            <table class="w-100" style="border:none;">
                                <tr v-for="(value, spec, index) in orderSpecs(row.item.specs)"
                                    style="border:none;background-color:unset !important;" :key="'spek-' + index">
                                    <td v-if="value.adj !== ''" style="border:none; padding:0px;width:80px;">{{ spec }}
                                    </td>
                                    <td v-if="value.adj !== ''" style="border:none; padding:0px;">: Rp. {{
            $helper.formatThousand(value.adj) }}</td>
                                </tr>
                            </table>
                        </div>
                        <div v-else class="text-muted">Tidak ada Harga</div>
                    </div>
                    <div v-else>
                        <b-form-group v-for="(value, spec, index) in row.item.editSpecs" :key="'spek-edit-' + index"
                            :label="'Spek ' + spec">
                            <b-input-group prepend="Rp.">
                                <b-form-input v-model="row.item.editSpecs[spec].adj"
                                    @input="sanitize(row.index, row.item, spec)"
                                    :disabled="row.item.isSubmitting" :id="'edit-spec-input-' + spec"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </div>
                </template>
                <template v-slot:cell(dimension)="row">
                    <div v-if="!row.item.isEditingDimension">
                        <div v-if="row.item.length != null && row.item.width != null && row.item.height != null">
                            {{ row.item.length }} x {{ row.item.width }} x {{ row.item.height }} (cm)</div>
                        <div v-else class="text-muted">Tidak ada dimensi</div>

                        <div v-if="row.item.weight != null">{{ row.item.weight }} (gr)</div>
                        <div v-else class="text-muted">Tidak ada berat</div>
                    </div>
                    <div v-else style="min-width: 275px;">
                        <b-form-group label="Dimensi">
                            <b-input-group>
                                <b-input-group-append>
                                    <b-input @keypress="numberOnly" v-model="row.item.editLength" id="edit-length-input"></b-input>
                                    <b-input-group-text>x</b-input-group-text>
                                    <b-input @keypress="numberOnly" v-model="row.item.editWidth" id="edit-width-input"></b-input>
                                    <b-input-group-text>x</b-input-group-text>
                                    <b-input @keypress="numberOnly" v-model="row.item.editHeight" id="edit-height-input"></b-input>
                                    <b-input-group-text>cm</b-input-group-text>
                                </b-input-group-append>
                            </b-input-group>
                            <small class="form-text text-muted">Panjang x Lebar x Tinggi</small>
                        </b-form-group>
                        <b-form-group label="Berat">
                            <b-input-group append="gr">
                                <b-form-input @keypress="numberOnly" v-model=row.item.editWeight id="edit-weight-input"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </div>
                </template>
                <template v-slot:cell(action)="row">
                    <div v-if="!row.item.isEditing && !row.item.isEditingDimension">
                        <div v-if="row.item.has_year == 0" style="display:inline-block;">
                            <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Detail"
                                @click="showDetail('t', row.item.id)" id="detail-button">
                                <i class="fa fa-fw fa-info" />
                            </b-button>
                            <!-- <b-button size="sm" class="ml-2" variant="primary" v-b-tooltip.hover.top title="Adjust Harga"
                                @click="toggleEditSpec(row.index, row.item)">
                                <i class="fa fa-fw fa-list-alt" />
                            </b-button> -->
                            <b-button size="sm" class="ml-2" variant="primary" v-b-tooltip.hover.top
                                title="Adjust Dimensi" @click="toggleEditDimension(row.index, row.item)" id="adjust-dimension-button">
                                <i class="fa fa-fw fa-list-alt" />
                            </b-button>
                            <router-link class="ml-2" :to="'/master/barang/t/' + row.item.id">
                                <b-button size="sm" variant="warning" v-b-tooltip.hover.top title="Edit" id="edit-button">
                                    <i class='fa fa-fw fa-pencil' />
                                </b-button>
                            </router-link>
                        </div>
                        <div v-else style="display:inline-block;">
                            <b-button size="sm" variant="success" v-b-tooltip.hover.top title="Lihat Tahunan / Generasi"
                                @click='showYears(row.item)' id="view-years-button">
                                <i class='fa fa-fw fa-list' />
                            </b-button>
                            <b-button size="sm" class="ml-2" variant="primary" v-b-tooltip.hover.top
                                title="Adjust Dimensi" @click="toggleEditDimension(row.index, row.item)" id="adjust-dimension-button">
                                <i class="fa fa-fw fa-list-alt" />
                            </b-button>
                        </div>
                    </div>
                    <div v-else-if="row.item.isEditing">
                        <b-button size="sm" variant="danger" :disabled="row.item.isSubmitting" v-b-tooltip.hover.top
                            title="Batal Adjust" @click="toggleEditSpec(row.index, row.item)" id="cancel-adjust-button">
                            <i class="fa fa-fw fa-close" />
                        </b-button>
                        <b-button size="sm" class="ml-2" variant="success" :disabled="row.item.isSubmitting"
                            v-b-tooltip.hover.top title="Simpan" @click="saveSpec(row.index)" id="save-spec-button">
                            <i class="fa fa-fw fa-check" />
                        </b-button>
                    </div>
                    <div v-else-if="row.item.isEditingDimension">
                        <b-button size="sm" variant="danger" :disabled="row.item.isSubmitting" v-b-tooltip.hover.top
                            title="Batal Adjust" @click="toggleEditDimension(row.index, row.item)" id="cancel-adjust-dimension-button">
                            <i class="fa fa-fw fa-close" />
                        </b-button>
                        <b-button size="sm" class="ml-2" variant="success" :disabled="row.item.isSubmitting"
                            v-b-tooltip.hover.top title="Simpan" @click="saveDimension(row.index)" id="save-dimension-button">
                            <i class="fa fa-fw fa-check" />
                        </b-button>
                    </div>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange"
                @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-detail" title="Detail Barang" size="lg" no-close-on-backdrop no-close-on-esc hide-footer>
            <DetailBarang :segment="detailSegment" :id="detailId" />
        </b-modal>
        <b-modal id="m-years" title="Daftar Tahun / Generasi" size="xl" no-close-on-backdrop no-close-on-esc
            hide-footer>
            <ListTahun :activeItem="activeItem" @show-detail="showDetailFromYear" />
        </b-modal>
        <b-modal id="m-download" :title="modalTitle" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="status == 0" id="preparing-file">
            Menyiapkan file Excel, mohon menunggu...
            </div>
            <div v-else-if="status == -1" id="failed-preparing-file">
            Gagal menyiapkan file Excel.
            </div>
            <div v-else id="file-ready">
            File Excel sudah siap. Tekan tombol dibawah ini untuk download file Excel.
            <div class="mt-2" id="download-button-container">
                <a :href="$BASE_FILE_PATH + path" download>
                <b-button variant="primary" id="download-excel-button">
                    <i class="fa fa-download mr-2" />Download Excel Laporan
                </b-button>
                </a>
            </div>
            </div>
        </b-modal>
        <!-- Modal Download Template Grade S -->
        <b-modal id="m-grade-s-download" size="lg" title="Download Template Grade S" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-row>
                <b-col md="6">
                    <b-form-group label="Nama Barang" id="gs-nama-group">
                        <b-form-input v-model="gradeS.filter.name" maxlength="50" id="gs-nama-input" />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Jenis" id="gs-jenis-group">
                        <multiselect v-model="gradeS.filter.kind" label="name" track-by="id" :internal-search="true"
                            deselect-label="" select-label="" :options="optKind" id="gs-jenis-select" />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Merk" id="gs-merk-group">
                        <multiselect v-model="gradeS.filter.brand" label="name" track-by="id" :internal-search="true"
                            :multiple="true" :close-on-select="false"
                            deselect-label="Hapus" select-label=""
                            :options="gradeS.optBrand"
                            :disabled="gradeS.filter.kind == null"
                            placeholder="Pilih Merk..."
                            id="gs-merk-select" />
                        <small v-if="gradeS.filter.brand.length > 0" class="text-muted">
                            {{ gradeS.filter.brand.length }} merk dipilih
                        </small>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Tipe" id="gs-tipe-group">
                        <b-input-group>
                            <b-form-input
                                readonly
                                :disabled="gradeS.filter.brand.length === 0"
                                :value="gradeS.filter.type.length === 0 ? '' : gradeS.filter.type.length + ' tipe dipilih'"
                                placeholder="Pilih Tipe..."
                                id="gs-tipe-trigger"
                                @click="openTypePicker()"
                                style="cursor: pointer; background-color: #fff;"
                            />
                            <b-input-group-append v-if="gradeS.filter.type.length > 0">
                                <b-button
                                    variant="outline-info"
                                    @click.stop="openTypePreview()"
                                    v-b-tooltip.hover title="Lihat tipe terpilih"
                                    id="gs-tipe-preview-btn"
                                >
                                    <i class="fa fa-eye" />
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <hr />
            <div v-if="gradeS.downloadStatus == 0" id="gs-preparing" class="text-muted">
                Menyiapkan template, mohon menunggu...
            </div>
            <div v-else-if="gradeS.downloadStatus == -1" id="gs-failed" class="text-danger">
                Gagal menyiapkan template. Coba lagi.
            </div>
            <div v-else-if="gradeS.downloadStatus == 1" id="gs-ready">
                Template siap diunduh.
                <div class="mt-2">
                    <a :href="$BASE_FILE_PATH + gradeS.downloadPath" download>
                        <b-button variant="primary" id="gs-download-button">
                            <i class="fa fa-download mr-2" />Unduh Template Excel
                        </b-button>
                    </a>
                </div>
            </div>
            <div class="mt-3 text-right" v-if="gradeS.downloadStatus != 0">
                <b-button variant="success" :disabled="gradeS.isDownloading" @click="downloadGradeSTemplate()" id="gs-generate-button">
                    {{ gradeS.isDownloading ? 'Menyiapkan...' : 'Buat Template' }}
                </b-button>
            </div>
        </b-modal>

        <!-- Modal Preview: Tipe Terpilih -->
        <b-modal id="m-grade-s-type-preview" title="Tipe Terpilih" centered hide-footer>
            <div v-if="gradeS.filter.type.length === 0" class="text-center text-muted py-4">
                Belum ada tipe yang dipilih.
            </div>
            <div v-else>
                <div class="mb-3">
                    <b-form-input
                        v-model="gradeS.typePreview.search"
                        placeholder="Cari tipe terpilih..."
                        id="gs-type-preview-search-input"
                    />
                </div>
                <div style="max-height: 360px; overflow-y: auto; border: 1px solid #dee2e6; border-radius: 4px;">
                    <div
                        v-for="(t) in filteredPreviewTypeOptions"
                        :key="t.id"
                        class="d-flex align-items-center px-3 py-2"
                        style="border-bottom: 1px solid #f0f0f0;"
                    >
                        <span class="text-muted mr-3" style="font-size: 0.8rem; min-width: 24px;">{{ gradeS.filter.type.indexOf(t) + 1 }}</span>
                        <span style="font-size: 0.9rem;">{{ t.name }}</span>
                    </div>
                    <div v-if="filteredPreviewTypeOptions.length === 0" class="text-center text-muted py-3">
                        Tidak ada tipe yang cocok dengan pencarian.
                    </div>
                </div>
                <div class="text-muted mt-2" style="font-size: 0.8rem;">Total: {{ gradeS.filter.type.length }} tipe</div>
            </div>
            <div class="text-right mt-3">
                <b-button variant="outline-primary" @click="openTypePickerFromPreview()" id="gs-type-preview-edit-btn">
                    <i class="fa fa-pencil mr-1" /> Edit Pilihan
                </b-button>
                <b-button variant="secondary" class="ml-2" @click="$bvModal.hide('m-grade-s-type-preview')" id="gs-type-preview-close-btn">
                    Tutup
                </b-button>
            </div>
        </b-modal>

        <!-- Modal Checkbox Picker: Pilih Tipe -->
        <b-modal id="m-grade-s-type-picker" title="Pilih Tipe" centered hide-footer no-close-on-backdrop no-close-on-esc>
            <div class="mb-2">
                <b-form-input
                    v-model="gradeS.typePicker.search"
                    placeholder="Cari tipe..."
                    id="gs-type-search-input"
                />
            </div>
            <div class="d-flex justify-content-between align-items-center mb-2">
                <small class="text-muted">{{ gradeS.typePicker.temp.length }} dari {{ gradeS.optType.length }} dipilih</small>
                <div>
                    <b-button variant="link" size="sm" class="p-0 text-primary" @click="selectAllTypes()" id="gs-type-select-all-btn">
                        Pilih Semua
                    </b-button>
                    <span class="text-muted mx-1">|</span>
                    <b-button variant="link" size="sm" class="p-0 text-danger" @click="clearAllTypes()" id="gs-type-clear-all-btn">
                        Hapus Semua
                    </b-button>
                </div>
            </div>
            <div style="max-height: 320px; overflow-y: auto; border: 1px solid #dee2e6; border-radius: 4px;">
                <div
                    v-for="opt in filteredTypeOptions"
                    :key="opt.id"
                    class="d-flex align-items-center px-3 py-2"
                    style="cursor: pointer; border-bottom: 1px solid #f0f0f0;"
                    @click="toggleTypePicker(opt)"
                >
                    <input
                        type="checkbox"
                        :checked="typePickerSelectedMap[opt.id]"
                        @click.stop="toggleTypePicker(opt)"
                        class="mr-2"
                        style="width: 16px; height: 16px; cursor: pointer; flex-shrink: 0;"
                    />
                    <span style="font-size: 0.9rem;">{{ opt.name }}</span>
                </div>
                <div v-if="filteredTypeOptions.length === 0" class="text-center text-muted py-3">
                    Tidak ada tipe yang cocok.
                </div>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-3">
                <small class="text-muted">{{ gradeS.typePicker.temp.length }} tipe dipilih</small>
                <div>
                    <b-button variant="secondary" @click="cancelTypePicker()" id="gs-type-cancel-btn">Batal</b-button>
                    <b-button variant="success" class="ml-2" @click="saveTypePicker()" id="gs-type-save-btn">
                        Simpan
                    </b-button>
                </div>
            </div>
        </b-modal>

        <!-- Modal Upload / Import Grade S -->
        <b-modal id="m-grade-s-upload" title="Import Excel Grade S" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group id="gs-upload-file-group">
                <b-form-file v-model="gradeS.fileUpload" :state="Boolean(gradeS.fileUpload)"
                    placeholder="Pilih file Excel Grade S"
                    drop-placeholder="Tarik dan lepas file di sini"
                    accept=".xlsx, .xls" id="gs-file-input" />
                <small class="text-muted mt-1 d-block">* Gunakan file template yang sudah diunduh. Isi hanya kolom <strong>nominal</strong> (Harga Grade S).</small>
                <small class="text-muted">* Baris dengan kolom nominal kosong akan dilewati secara otomatis.</small>
            </b-form-group>
            <div class="mt-3 text-right">
                <b-button variant="primary" @click="uploadGradeSTemplate()"
                    :disabled="!gradeS.fileUpload || gradeS.isSubmitting" id="gs-upload-button">
                    <i class="fa fa-upload mr-2" v-if="!gradeS.isSubmitting" />
                    {{ gradeS.isSubmitting ? 'Mengunggah...' : 'Unggah' }}
                </b-button>
            </div>
        </b-modal>

        <input style="opacity: 0; filter:alpha(opacity=0);" ref="fileupload" type="file" @change="onUploadTemplate"
            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" id="file-upload-input">

        <b-modal id="m-upload-template" title="Upload Template" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-alert show id="upload-template-alert">
            Upload Template Terakhir :
            <b-row v-for="(item, index) in templateLogs" :key="'template-log-' + index" :id="'template-log-' + index">
                <b-col md="10">
                <li class="mb-2">
                    {{ $helper.parseDate(item.upload_at) }} {{ $helper.parseHourMinute(item.upload_at) }}
                    <strong>({{ item.upload_by.fullname }})</strong>
                    <div class="small text-muted" style="margin-left:20px">
                    <span v-if="item.status == 1">ON PROGRESS</span>
                    <span v-if="item.status == 2">FINISHED</span>
                    </div>
                </li>
                </b-col>
                <b-col md="1">
                <b-button variant="primary" size="sm" :disabled="item.status == 1"
                    @click="downloadTemplateReport(item.report_path)" :id="'download-report-button-' + index"><i class="fa fa-download" /></b-button>
                </b-col>
            </b-row>
            </b-alert>
            <hr />
            <div class="mt-4 text-right" v-if="templateOnProgress === 'false'" id="upload-button-container">
            <b-button variant="primary" @click="uploadItemTemplate()" id="upload-button">Upload</b-button>
            </div>
            <div class="mt-4 text-right" v-else id="upload-button-container-disabled">
            <b-button variant="primary" disabled @click="uploadItemTemplate()" id="upload-button-disabled">Upload</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import DetailBarang from './DetailBarang.vue'
import ListTahun from './ListTahun.vue'
import EnumPermissions from '@/shared/enum-permissions'

export default {
    components: {
        DetailBarang, ListTahun
    },
    data() {
        return {

            status: 1, // 1: sukses, 0: loading, -1: error
            path: "",
            modalTitle: "",

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            detailId: 0,
            detailSegment: "t",

            filter: {
                name: "",
                kind: null,
                brand: null,
                gradeS: -1,
                hasYear: -1
            },

            options: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],

            fields: [
                { key: "item", label: "Barang", sortable: true },
                { key: "specs", label: "Harga" },
                { key: "adj_batangan", label: "Adj. Batangan", sortable: true },
                { key: "adj_grade_s", label: "Adj. Grade S", sortable: true },
                // { key: "price", label: "Harga Dasar", sortable: true },
                { key: "dimension", label: "Dimensi & Berat", thClass: "dimension-column", tdClass: "dimension-column" },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            activeItem: {
                id: null
            },
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optKind: [],
            optBrand: [],

            templateLogs: [],
            templateOnProgress: "",

            gradeS: {
                filter: {
                    name: "",
                    kind: null,
                    brand: [],
                    type: [],
                },
                optBrand: [],
                optType: [],
                typePicker: {
                    temp: [],
                    search: "",
                },
                typePreview: {
                    search: "",
                },
                downloadStatus: -2,  // -2: idle, 0: loading, 1: sukses, -1: error
                downloadPath: "",
                fileUpload: null,
                isDownloading: false,
                isSubmitting: false,
            }

        }
    },

    watch: {

        "filter.kind": function (newVal) {

            this.filter.brand = null
            this.optBrand = []

            if (newVal != null) {

                this.$axios.get("master/brands/" + this.filter.kind.id).then(res => {
                    this.optBrand = res.data.data
                    sessionStorage.setItem("listBarangFilter", JSON.stringify(this.filter))
                })

            }

        },

        "gradeS.filter.kind": function (newVal) {
            this.gradeS.filter.brand = []
            this.gradeS.optBrand = []
            this.gradeS.filter.type = []
            this.gradeS.optType = []

            if (newVal != null) {
                this.$axios.get("master/brands?kind_ids=" + newVal.id).then(res => {
                    this.gradeS.optBrand = res.data.data
                })
            }
        },

        "gradeS.filter.brand": {
            deep: true,
            handler(newVal) {
                this.gradeS.filter.type = []
                this.gradeS.optType = []

                if (newVal.length > 0) {
                    const brandIds = newVal.map(b => b.id).join(",")
                    this.$axios.get("master/types?brand_ids=" + brandIds).then(res => {
                        this.gradeS.optType = res.data.data
                    })
                }
            }
        }

    },

    methods: {

        openModalDownloadGradeS() {
            this.gradeS.filter.name = this.filter.name || ""
            this.gradeS.filter.kind = this.filter.kind || null
            this.gradeS.filter.brand = []
            this.gradeS.filter.type = []
            this.gradeS.typePicker.temp = []
            this.gradeS.typePicker.search = ""
            this.gradeS.optBrand = []
            this.gradeS.optType = []
            this.gradeS.downloadStatus = -2
            this.gradeS.downloadPath = ""

            if (this.gradeS.filter.kind != null) {
                this.$axios.get("master/brands?kind_ids=" + this.gradeS.filter.kind.id).then(res => {
                    this.gradeS.optBrand = res.data.data
                })
            }

            this.$bvModal.show("m-grade-s-download")
        },

        openTypePicker() {
            if (this.gradeS.filter.brand.length === 0) return
            this.gradeS.typePicker.temp = [...this.gradeS.filter.type]
            this.gradeS.typePicker.search = ""
            this.$bvModal.show("m-grade-s-type-picker")
        },

        toggleTypePicker(opt) {
            const idx = this.gradeS.typePicker.temp.findIndex(t => t.id === opt.id)
            if (idx === -1) {
                this.gradeS.typePicker.temp.push(opt)
            } else {
                this.gradeS.typePicker.temp.splice(idx, 1)
            }
        },

        saveTypePicker() {
            this.gradeS.filter.type = [...this.gradeS.typePicker.temp]
            this.$bvModal.hide("m-grade-s-type-picker")
        },

        cancelTypePicker() {
            this.$bvModal.hide("m-grade-s-type-picker")
        },

        selectAllTypes() {
            this.gradeS.typePicker.temp = [...this.gradeS.optType]
        },

        clearAllTypes() {
            this.gradeS.typePicker.temp = []
        },

        openTypePreview() {
            this.gradeS.typePreview.search = ""
            this.$bvModal.show("m-grade-s-type-preview")
        },

        openTypePickerFromPreview() {
            this.$bvModal.hide("m-grade-s-type-preview")
            this.$nextTick(() => {
                this.gradeS.typePicker.temp = [...this.gradeS.filter.type]
                this.gradeS.typePicker.search = ""
                this.$bvModal.show("m-grade-s-type-picker")
            })
        },

        downloadGradeSTemplate() {
            this.gradeS.downloadStatus = 0
            this.gradeS.isDownloading = true

            let param = ""

            if (!this.$helper.isBlank(this.gradeS.filter.name)) {
                param += "&item_name=" + this.gradeS.filter.name
            }
            if (this.gradeS.filter.kind != null) {
                param += "&kind_id=" + this.gradeS.filter.kind.id
            }
            if (this.gradeS.filter.brand.length > 0) {
                param += "&brand_ids=" + this.gradeS.filter.brand.map(b => b.id).join(",")
            }
            if (this.gradeS.filter.type.length > 0) {
                param += "&type_ids=" + this.gradeS.filter.type.map(t => t.id).join(",")
            }

            if (param) {
                param = "?" + param.substring(1)
            }

            this.$axios.post(`master/item/download-excel-grade-s${param}`).then(res => {
                this.gradeS.downloadStatus = 1
                this.gradeS.downloadPath = res.data.data.path
            }).catch(error => {
                this.gradeS.downloadStatus = -1
                this.$helper.parseError(this, error)
            }).finally(() => {
                this.gradeS.isDownloading = false
            })
        },

        openModalUploadGradeS() {
            this.gradeS.fileUpload = null
            this.gradeS.isSubmitting = false
            this.$bvModal.show("m-grade-s-upload")
        },

        uploadGradeSTemplate() {
            if (!this.gradeS.fileUpload) {
                return this.$helper.toastError(this, "Pilih file Excel terlebih dahulu.")
            }

            this.gradeS.isSubmitting = true
            const formData = new FormData()
            formData.append("file", this.gradeS.fileUpload)

            this.$axios.post("master/item/upload-excel-grade-s", formData, {
                headers: { "Content-Type": "multipart/form-data" }
            }).then(() => {
                this.$helper.toastSuccess(this, "File Grade S berhasil diunggah dan sedang diproses!")
                this.gradeS.fileUpload = null
                this.$bvModal.hide("m-grade-s-upload")
                this.getItems()
            }).catch(error => {
                this.$helper.parseError(this, error)
            }).finally(() => {
                this.gradeS.isSubmitting = false
            })
        },

        downloadItemTemplate() {

            this.modalTitle = "Template Item"
            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("master/item/download-excel-template").then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })
        },

        generateItemMaster() {
            this.modalTitle = "Master Item"
            this.$bvModal.show("m-download")
            this.status = 0

            let param = "";

            if (!this.$helper.isBlank(this.filter.name)) {
                param += "&filterName=" + this.filter.name;
            }

            if (this.filter.kind != null) {
                param += "&filterKind=" + this.filter.kind.id;
            }

            if (this.filter.brand != null) {
                param += "&filterBrand=" + this.filter.brand.id;
            }

            if (this.filter.gradeS !== -1) {
                param += "&filterGradeS=" + this.filter.gradeS;
            }

            if (param) {
                param = "?" + param.substring(1);
            }

            this.$axios.post(`master/item/download-excel-master${param}`).then(res => {

                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })
        },

        generatePriceList() {
            this.modalTitle = "Price List"
            this.$bvModal.show("m-download")
            this.status = 0
            this.$axios.post("report/pricelist-report").then(res => {
                this.status = 1
                this.path = res.data.data.path

            })
                .catch(error => {
                    this.status = -1
                    this.$helper.parseError(this, error)
                })
        },

        prepareUploadTemplate() {

            this.$axios.get("master/item/upload-template-log?count=5").then(res => {
                this.templateLogs = res.data.data
            })

            this.$axios.get("master/item/allow-upload-template").then(res => {
                this.templateOnProgress = res.data.data
            })

            this.$bvModal.show('m-upload-template')
        },

        downloadTemplateReport(path) {
            window.open(this.$BASE_FILE_PATH + path)
        },

        uploadItemTemplate() {
            this.$refs.fileupload.click()
        },

        onUploadTemplate(e) {
            this.initStatus = 0
            // this.modalTitle = "Laporan Upload"
            // this.$bvModal.show("m-download")
            this.status = 0
            let payload = new FormData()
            payload.append("file", e.target.files[0])

            this.$axios.post("master/item/upload-excel-template", payload).then(res => {
                // this.status = 1
                // this.path = res.data.data.path
            })
                .catch(error => {
                    // this.initStatus = -1
                    this.$helper.parseError(this, error)
                })
            // .finally(() => {
            // })
            this.$bvModal.hide('m-upload-template')
            this.$helper.toastSuccess(this, "Template sedang di-proses!")
            this.getItems()
            this.initStatus = 1
            this.$refs.fileupload.value = null
        },

        init() {

            this.initStatus = 0
            let getItems = this.getItems()
            // only fetch data whose category is electornic
            let getMasterKind = this.$axios.get("master/kinds?category=ELEK").then(res => {
                this.optKind = res.data.data
            })

            Promise.all([getItems, getMasterKind]).then(() => {
                this.initStatus = 1
            })
                .catch(error => {
                    this.initStatus = -1
                })

        },

        showDetail(segment, id) {
            this.detailId = id
            this.detailSegment = segment
            this.$bvModal.show('m-detail')
        },

        showYears(item) {
            this.activeItem = item
            this.$bvModal.show('m-years')
        },

        showDetailFromYear(id) {
            this.showDetail('y', id)
        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if (isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if (!this.$helper.isBlank(this.filter.name)) {
                param += "&filterName=" + this.filter.name
            }

            if (this.filter.kind != null) {
                param += "&filterKind=" + this.filter.kind.id
            }

            if (this.filter.brand != null) {
                param += "&filterBrand=" + this.filter.brand.id
            }

            if (this.filter.gradeS != -1) {
                param += "&filterGradeS=" + this.filter.gradeS
            }

            if (this.filter.hasYear != -1) {
                param += "&filterHasYear=" + this.filter.hasYear
            }

            if (!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("master/item" + param).then(res => {
                this.items = res.data.data.items.map(item => {
                    let editSpecs = {}
                    let specs = {}
                    let hasSpecs = false
                    for (let i = 0; i < item.itemSpecs.length; i++) {
                        editSpecs[item.itemSpecs[i].name] = {
                            id: item.itemSpecs[i].id,
                            adj: ""
                        }
                        specs[item.itemSpecs[i].name] = {
                            id: item.itemSpecs[i].id,
                            adj: ""
                        }
                        for (let j = 0; j < item.typePrices.length; j++) {
                            if (item.itemSpecs[i].id == item.typePrices[j].id) {
                                specs[item.itemSpecs[i].name].adj = item.typePrices[j].price
                                hasSpecs = true
                                break
                            }
                        }
                    }
                    return {
                        id: item.id,
                        type: item.type,
                        price: item.price,
                        has_year: item.has_year,
                        adj_batangan: item.adj_batangan,
                        adj_grade_s: item.adj_grade_s,
                        brand: item.brand,
                        kind: item.kind,
                        specs: specs,
                        editBatangan: "",
                        editGradeS: "",
                        editSpecs: editSpecs,
                        hasSpecs: hasSpecs,
                        isEditing: false,
                        isSubmitting: false,
                        length: item.length,
                        width: item.width,
                        height: item.height,
                        weight: item.weight,
                        isEditingDimension: false,
                        editLength: "",
                        editWidth: "",
                        editHeight: "",
                        editWeight: ""
                    }
                })
                this.totalRows = res.data.data.total
                sessionStorage.setItem("listBarangFilter", JSON.stringify(this.filter))
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isBusy = false
                })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

        toggleEditSpec(index, item) {
            if (!this.items[index].isEditing) {
                this.items[index].editBatangan = this.items[index].adj_batangan
                this.items[index].editGradeS = this.items[index].adj_grade_s
                for (const [key, value] of Object.entries(this.items[index].specs)) {
                    this.items[index].editSpecs[key].adj = value.adj
                }
                this.items[index].isEditing = true
            }
            else {
                this.items[index].editBatangan = ""
                this.items[index].editGradeS = ""
                for (const [key, _] of Object.entries(this.items[index].editSpecs)) {
                    this.items[index].editSpecs[key].adj = ""
                }
                this.items[index].isEditing = false
            }

            this.sanitizeAll(index, item)
        },

        saveSpec(index) {

            this.items[index].isSubmitting = true

            // this.items[index].editSpecs.BM.adj = (this.items[index].editSpecs.BM.adj ? this.$helper.toNumber(this.items[index].editSpecs.BM.adj) : null)
            //this.items[index].editSpecs.DISTRI.adj = (this.items[index].editSpecs.DISTRI.adj ? this.$helper.toNumber(this.items[index].editSpecs.DISTRI.adj) : null)
            // this.items[index].editSpecs.REKONDISI.adj = (this.items[index].editSpecs.REKONDISI.adj ? this.$helper.toNumber(this.items[index].editSpecs.REKONDISI.adj) : null)
            this.items[index].editSpecs.RESMI.adj = (this.items[index].editSpecs.RESMI.adj ? this.$helper.toNumber(this.items[index].editSpecs.RESMI.adj) : null)

            let payload = {
                id: this.items[index].id,
                adjBatangan: this.items[index].editBatangan != "" ? this.$helper.toNumber(this.items[index].editBatangan) : null,
                adjS: (this.items[index].editGradeS ? this.$helper.toNumber(this.items[index].editGradeS) : null),
                adjSpec: Object.entries(this.items[index].editSpecs).map(item => item[1]),
                part: "t"
            }

            this.$axios.post("master/item/update-simple", payload).then(res => {
                if (res.status == 200) {
                    this.$helper.toastSuccess(this, "Adjustment harga berhasil disimpan!")
                    this.items[index].editBatangan = ""
                    this.items[index].editGradeS = ""
                    for (const [key, _] of Object.entries(this.items[index].editSpecs)) {
                        this.items[index].editSpecs[key].adj = ""
                    }
                    this.items[index].isEditing = false
                    this.items[index].isSubmitting = false
                    this.getItems()
                }
                else {
                    this.$helper.toastError(this, "Terjadi kesalahan pada server, silahkan coba lagi")
                    this.items[index].isSubmitting = false
                }
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.items[index].isSubmitting = false
                })
        },

        toggleEditDimension(index, item) {
            if (!this.items[index].isEditingDimension) {
                this.items[index].editLength = this.items[index].length
                this.items[index].editWidth = this.items[index].width
                this.items[index].editHeight = this.items[index].height
                this.items[index].editWeight = this.items[index].weight
                this.items[index].isEditingDimension = true
            } else {
                this.items[index].editLength = ""
                this.items[index].editWidth = ""
                this.items[index].editHeight = ""
                this.items[index].editWeight = ""
                this.items[index].isEditingDimension = false
            }
        },

        saveDimension(index) {
            this.items[index].isSubmitting = true
            let payload = {
                id: this.items[index].id,
                length: this.items[index].editLength,
                width: this.items[index].editWidth,
                height: this.items[index].editHeight,
                weight: this.items[index].editWeight
            }

            this.$axios.post("master/item/update-dimension", payload).then(res => {
                if (res.status == 200) {
                    this.$helper.toastSuccess(this, "Dimensi barang berhasil disimpan!")
                    this.items[index].editLength = ""
                    this.items[index].editWidth = ""
                    this.items[index].editHeight = ""
                    this.items[index].editWeight = ""
                    this.items[index].isEditingDimension = false
                    this.items[index].isSubmitting = false
                    this.getItems()
                } else {
                    this.$helper.toastError(this, "Terjadi kesalahan pada server, silahkan coba lagi")
                    this.items[index].isSubmitting = false
                }
            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.items[index].isSubmitting = false
                })
        },

        sanitizeAll(index, item) {
            this.sanitize(index, item, "editBatangan")
            this.sanitize(index, item, "editGradeS")
            this.sanitize(index, item, "BM")
            //this.sanitize(index, item, "DISTRI")
            this.sanitize(index, item, "REKONDISI")
            this.sanitize(index, item, "RESMI")
        },

        sanitize(index, item, column) {
            if (column == "editBatangan") {
                let cleaned = String(item.editBatangan).replace(/\./g, "")
                let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                item.editBatangan = res
            } else if (column == "editGradeS") {
                let cleaned = String(item.editGradeS).replace(/\./g, "")
                let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                item.editGradeS = res
            } else if (column == "BM") {
                let cleaned = String(item.editSpecs.BM.adj).replace(/\./g, "")
                let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                item.editSpecs.BM.adj = res
            } else if (column == "REKONDISI") {
                let cleaned = String(item.editSpecs.REKONDISI.adj).replace(/\./g, "")
                let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                item.editSpecs.REKONDISI.adj = res
            } else if (column == "RESMI") {
                let cleaned = String(item.editSpecs.RESMI.adj).replace(/\./g, "")
                let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                item.editSpecs.RESMI.adj = res
            }
            // else if(column == "DISTRI"){
            //     let cleaned = String(item.editSpecs.DISTRI.adj).replace(/\./g, "")
            //     let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            //     item.editSpecs.DISTRI.adj = res
            // }
        },

        numberOnly(event) {
            if (event.charCode >= 48 && event.charCode <= 57 || event.charCode == 13) {
                return true
            } else {
                event.preventDefault()
            }
        },

        resetFilter() {
            this.filter = {
                name: "",
                kind: null,
                brand: null,
                gradeS: -1,
                hasYear: -1
            }
            this.getItems()
        },
        orderSpecs(specs) {

            console.log("specs", specs)

            let order = {
                "RESMI": { adj: "" },
                "LN": { adj: "" },
                "RR": { adj: "" }
            }

            for (const [key, value] of Object.entries(specs)) {
                if (key == "RESMI") {
                    order.RESMI.adj = value.adj
                } else if (key == "LN") {
                    order.LN.adj = value.adj
                } else if (key == "RR") {
                    order.RR.adj = value.adj
                }
            }

            return order


        }

    },

    computed: {
        isAllowedGradeS() {
            return (
                this.$helper.checkRoleNumber(
                    EnumPermissions.MASTER_ADJ_HARGA_GRADE_S.toString(),
                    localStorage.getItem("permissions")
                ) || localStorage.getItem("roleName").includes("Superadmin")
            )
        },

        typePickerSelectedMap() {
            const map = {}
            for (let i = 0; i < this.gradeS.typePicker.temp.length; i++) {
                map[this.gradeS.typePicker.temp[i].id] = true
            }
            return map
        },

        filteredTypeOptions() {
            const q = this.gradeS.typePicker.search.toLowerCase()
            if (!q) return this.gradeS.optType
            return this.gradeS.optType.filter(opt => opt.name.toLowerCase().includes(q))
        },

        filteredPreviewTypeOptions() {
            const q = this.gradeS.typePreview.search.toLowerCase()
            if (!q) return this.gradeS.filter.type
            return this.gradeS.filter.type.filter(opt => opt.name.toLowerCase().includes(q))
        }
    },

    created() {
        if (!this.$helper.isBlank(sessionStorage.getItem("listBarangFilter"))) {
            this.filter = JSON.parse(sessionStorage.getItem("listBarangFilter"))
        }
        this.init()
    }

}
</script>

<style scoped>
/deep/.dimension-column {
    max-width: 300px;
}
</style>
